interface StringResources {
  [key: string]: string;
}

const strings: StringResources = {
  //Common page
  "common.bookmark.more.hotels": "Bookmark More Hotels",
  "common.inProgress": "In Progress",
  "common.not.inProgress": "Not In Progress",
  "common.bookmarkedHotels": "Bookmarked Hotels",
  "common.bookmarkedPlans": "Bookmarked Plans",
  "common.templatePlans": "Template Plans",
  "common.propertyPlans": "Property Plans",
  "common.remove": "Remove",
  "common.proceed": "Proceed",
  "common.seeAll": "See all",
  "common.seeLess": "See less",
  "common.seeMore": "See More",
  "common.seeLessUpper": "See Less",
  "common.includeAboveProperty": "Include Above Property",
  "common.excludeAboveProperty": "Exclude Above Property",

  //Dashboard Page
  "dashboard.heading": " My Portfolio Dashboard",
  "dashboard.hotelView": "Hotel View",
  "dashboard.planView": "Plan View",
  "dashboard.bookmarkThisHotel": "Bookmark this Hotel",
  "dashboard.bookmarkThisPlan": "Bookmark this Plan",
  "dashboard.removeBookmark": "Remove Bookmark",
  "dashboard.assigned.progress.completed": "Assigned, In Progress & Completed",
  "dashboard.assigned.templatePlans": "Assigned Template Plans",
  "dashboard.brand.deadlines": "Brand Deadlines",
  "dashboard.initiatives": "Initiatives",
  "dashboard.planInProgress": "Plan in Progress",
  "dashboard.bookmark.hotels": "Bookmark More Hotels",
  "dashboard.PlanView.BrandDeadline": "brandDeadlineFilters",
  "dashboard.PlanView.FunctionalArea": "Functional Areas",
  "dashboard.PlanLabel": "Plans",
  "dashboard.ChangeEmail": "Change Email",
  "dashboard.UpdateEmail": "Update email",
  "dashboard.SearchBarPlaceholder": "Search by plan title",
  "dashboard.IndividualProperty.Initiative": "initiatives",
  "dashboard.AboveProperty.Bookmarked.Template": "Template",
  "dashboard.PreferredEmailTitle": "All of your BOOST messages and notifications are being sent to ",
  "dashboard.PreferredEmailDescription": "You will not receive email notifications as your Email Id is not available.",
  "dashboard.AboveProperty.assignmentSummary": "All actions will be automatically assigned to the Plan Owner.",
  "dashboard.planAssignment.plan": "Plan Assignment - Plan Selection",
  "dashboard.planAssignment.user": "Plan Assignment - User Selection",
  "dashboard.focusedArea.flagTrue.desktop": "Note: There are new focus areas!",
  "dashboard.focusedArea.flagTrue.mobile": "New focus areas",

  //My Plan Page
  "myplan.createTemplatePlan": "A plan with no inncode associated",
  "myplan.TemplatePlan": "New Template Plan",
  "myplan.createPropertyPlan": "A plan for specific Inncode",
  "myplan.PropertyPlan": "New Property Plan",
  "myPlan.importFromLibrary.feedback": "Action(s) Added. Well-done customizing your plan!",
  "myPlan.removeUser.popup.heading": "Remove Member",
  "myPlan.removeUser.popup.desc": "Action(s) will be reassigned to the Plan Owner. Do you wish to proceed?",
  "myPlan.myCompleted.popup.desc":
    "{totalAction} action(s) {prep} the entire {plan} will be marked completed, including those <strong>not</strong> assigned to you.",
  "myPlan.myCompletedTask.popup.desc":
    "{totalAction} action(s) assigned to you will be marked completed. To mark the entire plan complete, unclick the Highlight My Actions button.",
  "myPlan.changeAction.status.popup":
    "This action is not assigned to you. Do you want to proceed to update the status?",
  "myPlan.actionDisabled.feedback":
    "This action is not assigned to you. To manage actions on the entire plan, unclick the Highlight My Actions button.",
  "myplan.actionCompleted.feedback": "All actions are already marked completed.",
  "myplan.removeAssigee.popup.desc":
    "The Plan Member will be removed from the plan and any actions. Do you wish to proceed?",
  "myPlan.sectionHeader.completed.heading": "Are you sure you want to proceed and mark the {plan} complete?",
  "myplan.myCompletedTask.popup.heading.highlightToggle":
    "Are you sure you want to proceed and mark the plan complete?",
  "myplan.highlight.myActions": "Highlight My Actions",
  "myPlan.reassignOwner": "Reassign to Plan Owner",
  "myPlan.inviteMember.popup": "Select the user(s) to be added to this plan.",
  "myPlan.createNewAction": "Create new action",
  "myPlan.editAction": "Edit action",
  "myPlan.memberRemoval": "Plan Member Removed",

  //Library page
  "library.addToMyPlan": "Add to My Plans",
  "library.addToMyPlan.popup.desc": "Brand deadline date is ",
  "library.copyActionToMyPlan.popup.title": "Copy action to a plan",
  "library.copyActionToMyPlan.popup.createPlanButtonLabel": "Create New Plan",
  "library.planDetails.section.kebabMenu.copyLinkTitle": "Copy shareable link",
  "library.planDetails.section.kebabMenu.copySectionTitle": "Copy Section to Plan",
  "library.addToMyPlan.popup.subDesc": "Select Date will allow you to set a different due date.",
  "library.addToMyPlan.popup.beyondDate": "Selected date is later than the deadline. Do you want to continue?",

  //Impersonate page
  "impersonate.header.tooltip":
    "Locate the On- or Above-Property user you wish to impersonate by searching for one of their associated Inncodes.",

  "user.restrictAccess":
    "You do not have permission to use this function. Reach out to BOOST.Support@hilton.com for more information or to request access."
};

export default strings;
